import { Button, Input } from "antd";
import { Digest } from "./[topicId]/edit.page";
import { useState } from "react";

export function DigestPrompt(props: { digest: Digest }) {
  const [prompt, setPrompt] = useState(props.digest.link?.json.prompt);
  const link = props.digest.link!;
  return (
    <div style={{ marginLeft: 16 }}>
      <Input.TextArea
        style={{ marginBottom: 16, marginRight: 10, minHeight: 500 }}
        rows={10}
        placeholder="enter prompt"
        defaultValue={prompt}
        onChange={(e) => setPrompt(e.target.value)}
      />
      <Button
        type="primary"
        onClick={(e) =>
          props.digest.save({
            id: link.id,
            name: link.name,
            description: link.description,
            ...link.json,
            prompt: prompt!,
          })
        }
      >
        Save prompt
      </Button>
    </div>
  );
}
